const GF = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3csvg%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2090%2060'%3e%3cpolygon%20fill='%23FDEB01'%20points='0,0%2090,60%200,60%20'/%3e%3cpolygon%20fill='%2358A846'%20points='90,0%2090,60%200,0%20'/%3e%3cpolygon%20fill='%23ED3D24'%20points='50.7,33.3%2060,26.6%2048.5,26.6%2045,15.7%2041.5,26.6%2030,26.6%2039.3,33.3%2035.7,44.3%2045,37.6%2054.3,44.3%20'/%3e%3c/svg%3e";
export {
  GF as default
};
//# sourceMappingURL=GF.svg.es.js.map
